<template>
    <div class="info">
        <nav>
            <button class="button" @click="toggleMenu">
                <IconComponent class="icon" :class="{ open: isMenuOpen }" icon="dotdot" />
            </button>
            <ul v-if="isMenuOpen">
                <li><router-link :to="`/medialinks/${projectId}`">Ficheiros e endereços</router-link></li>
                <li @click="endingProject" v-if="canEndProject && project.worker != null">
                    <router-link to="/projects">
                        {{ project.done ? 'Reabrir Projecto' : 'Finalizar Projecto' }}
                    </router-link>
                </li>
            </ul>
        </nav>
        <h2 v-if="project" v-html="project.name"></h2>
        <p v-if="project" v-html="project.description"></p>
    </div>
</template>

<script>
import IconComponent from '@/components/Icons.vue'

export default {
    name: 'ChatProjectFilesAndInfo',
    props: {
        projectId: { required: true }
    },
    components: {
        IconComponent,
    },
    data() {
        return {
            currentView: null,
            isMenuOpen: false,
        }
    },
    methods: {
        endingProject() {
            if (this.project) {
                this.$store.dispatch('projects/toggleDone', this.project);
            }
        },
        toggle(view) {
            if (this.currentView === view) {
                this.currentView = null
            } else {
                this.currentView = view
            }
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
    },
    computed: {
        canEndProject() {
            return this.role == 'admin' || this.role == 'worker'
        },
        project() {
            return this.$store.getters['projects/id'](this.projectId)
        },
        role() {
            return this.$store.state.users.role
        },
    },

    watch: {
        projectId: {
            immediate: true,
            handler() {
                this.$store.dispatch('projects/getAll', this.projectId)
            },
        }
    },
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.info {
    text-align: center;
    padding: 1.5em;
    z-index: 0;

    nav {
        text-align: center;
        margin-top: 1em;
        display: flex;
        justify-content: end;
    
        button {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            width: 1px;
            height: 20px;
            background: none;
            border: none;
            padding: 0;
            position: absolute;
    
            .icon {
                width: 18px;
                height: 20px;
                fill: var(--text-second-color);
                transition: fill 0.3s;
        
                &:last-child {
                    display: flex;
                    align-items: left;
                    justify-content: right;
                }
            }
        }
    
        ul {
            margin: -18px 1rem 0;
            padding: .5rem;
            list-style: none;
            background-color: var(--bg-color-2);
            position: absolute;
            border-radius: 5px;
    
            li {
                margin: 0.5em 0;
    
                a {
                    text-decoration: none;
                    color: var(--text-color);
                    font-size: 16px;
                    transition: color 0.3s;
    
                    &:hover {
                        color: var(--secondary-color);
                    }
                }
            }
        }
    }

    h2 {
        text-transform: uppercase;
        font-size: 16px;
        margin: 0;
        margin-bottom: 1em;

    }

    p {
        margin: 0;

        :deep(a) {
            color: var(--highlight-color);
        }
    }
}

</style>
